export default __webpack_public_path__ + "static/media/we-subject-pronoun-2.09677de9.png";